export default __webpack_public_path__ + "static/media/smoking_rooms.6e45036f.svg";